import { render, staticRenderFns } from "./uiPost.vue?vue&type=template&id=7a75c850&scoped=true"
import script from "./uiPost.vue?vue&type=script&lang=js"
export * from "./uiPost.vue?vue&type=script&lang=js"
import style0 from "./uiPost.vue?vue&type=style&index=0&id=7a75c850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a75c850",
  null
  
)

export default component.exports